import affirmativeStyles from './Affirmative.module.css'
import affirmativeSprite from './Affirmative.svg'
import celebrateStyles from './Celebrate.module.css'
import celebrateSprite from './Celebrate.svg'
import confirmStyles from './Confirm.module.css'
import confirmSprite from './Confirm.svg'
import idleStyles from './Idle.module.css'
import idleSprite from './Idle.svg'
import jumpWiggleStyles from './JumpWiggle.module.css'
import jumpWiggleSprite from './JumpWiggle.svg'
import negativeStyles from './Negative.module.css'
import negativeSprite from './Negative.svg'
import staticStyles from './Static.module.css'
import staticSprite from './Static.svg'
import thinkingStyles from './Thinking.module.css'
import thinkingSprite from './Thinking.svg'
import tickleStyles from './Tickle.module.css'
import tickleSprite from './Tickle.svg'
import userInputStyles from './UserInput.module.css'
import userInputSprite from './UserInput.svg'

interface SpriteDefinition {
  /** URL of the static SVG sprite sheet, applied as a CSS mask. */
  sprite: string
  /** CSS module class that defines the sprite dimensions and animation keyframes. */
  className: string
}

/**
 * Maps each sprite-based animation type to its static SVG asset and CSS module class. `activate` is
 * excluded because it composes the `celebrate` sprite with its own animated sparkles. The keys must
 * stay in sync with `CopilotAnimationType` (minus `activate`); `CopilotAnimation` indexes this
 * registry with an animation type, so a missing key surfaces as a type error at the call site.
 */
export const spriteRegistry = {
  affirmative: {sprite: affirmativeSprite, className: affirmativeStyles.affirmative},
  celebrate: {sprite: celebrateSprite, className: celebrateStyles.celebrate},
  confirm: {sprite: confirmSprite, className: confirmStyles.confirm},
  idle: {sprite: idleSprite, className: idleStyles.idle},
  jumpWiggle: {sprite: jumpWiggleSprite, className: jumpWiggleStyles.jumpWiggle},
  negative: {sprite: negativeSprite, className: negativeStyles.negative},
  static: {sprite: staticSprite, className: staticStyles.static},
  thinking: {sprite: thinkingSprite, className: thinkingStyles.thinking},
  tickle: {sprite: tickleSprite, className: tickleStyles.tickle},
  userInput: {sprite: userInputSprite, className: userInputStyles.userInput},
} satisfies Record<Exclude<import('../types').CopilotAnimationType, 'activate'>, SpriteDefinition>
